import { ResponseDto } from "@common/ict/model/interface/common";
import { AxiosInstance } from "axios";
import { SendEmailPasswordDto } from "@common/ict/model/interface/email";
import { ICT2B_CONFIG } from "@/zh-website/src/config";

export function sendEmailPasswordApi(
  request: AxiosInstance,
  params: SendEmailPasswordDto
) {
  return request.get<ResponseDto, ResponseDto>(
    `${ICT2B_CONFIG.EMAIL_URL}EmailService/SendEmailPassword`,
    {
      params
    }
  );
}
